import { DesignSystemPage } from '@repo/ui/features/platform';

export default function SuperAdminDesignSystemPage() {
  return (
    <div className="w-full py-6">
      <DesignSystemPage />
    </div>
  );
}
